'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Flex, Heading, Text } from '@chakra-ui/react'

import { CustomerInfo } from 'app/utils/authentication'
import { Input } from 'components/form/Input'
import { Button } from 'components/ui/Buttons/Button'
import { Container } from 'styles/shared'

import { NewsletterLogic } from '../../../../components/partials/shared/Newsletter/NewsletterLogic'

type Props = {
  customerInfo: CustomerInfo | undefined
}

export const Newsletter = ({ customerInfo }: Props): JSX.Element | null => {
  const { t } = useTranslation(['common', 'newsletter'])

  const isUserInNewsletter = customerInfo?.customer?.newsletterSubscription
  if (isUserInNewsletter) {
    return null
  }

  return (
    <NewsletterLogic
      children={({ getFieldProps, touched, handleSubmit, errors }) => (
        <Box backgroundColor="green.a150" paddingY={{ base: '28px', md: '54px' }}>
          <Container>
            <Flex
              justifyContent="space-between"
              alignItems={{ md: 'center' }}
              flexDirection={{ base: 'column', md: 'row' }}
            >
              <Box width={{ md: '50%' }}>
                <Heading
                  as="h3"
                  color="white"
                  fontWeight="normal"
                  marginBottom={{ base: '16px', md: 0 }}
                  fontSize={{ base: 'lg', md: '2xl' }}
                  lineHeight={{ base: 1.33, md: 1.2 }}
                >
                  {t('newsletter:header')}
                </Heading>
                <Text
                  color="white"
                  fontSize={{ base: 'sm', md: 'md' }}
                  marginBottom={{ base: '36px', md: 0 }}
                  fontWeight={300}
                >
                  {t('newsletter:body')}
                </Text>
              </Box>
              <Flex flexDirection={{ base: 'column', md: 'row' }} width={{ md: '50%' }}>
                <Box marginBottom={{ base: '36px', md: 0 }} width="100%">
                  <Input
                    {...getFieldProps('email')}
                    placeholder={t('newsletter:emailPlaceholder')}
                    name="email"
                    touched={touched.email}
                    error={errors.email}
                    label={t('newsletter:emailPlaceholder')}
                  />
                </Box>

                <Box width={{ md: '200px' }} marginLeft={{ md: '12px' }}>
                  <Button onClick={handleSubmit} className="gtm-subscribe-to-newsletter">
                    {t('newsletter:cta')}
                  </Button>
                </Box>
              </Flex>
            </Flex>
          </Container>
        </Box>
      )}
    />
  )
}
